module.exports = __webpack_public_path__ + "img/icono-ondas.6de963bb.svg";